import { inject, ModuleWithProviders, NgModule } from '@angular/core';
import { AuthState } from '@plys/src/auth/application/auth.state';
import { AUTH_STRATEGY } from '@plys/src/auth/application/auth.strategy';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { JwtAuthStrategy } from '@plys/src/auth/infrastructure/jwt-auth.strategy';
import { AUTH_STORAGE } from '@plys/src/auth/infrastructure/token.repository';

export type AuthType = 'jwt';

@NgModule({
  imports: [RecaptchaV3Module],
  exports: [],
  declarations: [],
  providers: [AuthState],
})
export class AuthModule {
  static forRoot(authType: AuthType, recaptchaSiteKey: string): ModuleWithProviders<AuthModule> {
    return {
      providers: [
        {
          provide: RECAPTCHA_V3_SITE_KEY,
          useValue: recaptchaSiteKey,
        },
        {
          provide: AUTH_STRATEGY,
          useFactory: () => {
            switch (authType) {
              case 'jwt':
                return inject(JwtAuthStrategy);
              default:
                throw new Error(`Unknown auth type: ${authType}`);
            }
          },
        },
        {
          provide: AUTH_STORAGE,
          useValue: localStorage,
        },
      ],
      ngModule: AuthModule,
    };
  }
}
